import React from 'react';
import {useSelector} from "react-redux";

import styles from './AdditionalServices.module.scss';
import AdditionalServiceItem from "./AdditionalServiceItem/AdditionalServiceItem";

const AdditionalServices = () => {
    const {additionalServices} = useSelector(state => state.additionalServices); // default additional services from DB, service_type: Генеральне

    return (
        <div className={styles.services}>
            {
                additionalServices?.map((item, index) =>
                    <AdditionalServiceItem
                        key={index}
                        id={item.id}
                        icon={item.svg_image}
                        price={item.price}
                        name={item.name}
                    />)
            }
        </div>
    );
};

export default AdditionalServices;
